export const ref = {
  key: '29531534-c6f4c4079f81828b6fd250707',
  URL: 'https://pixabay.com/api/',
  image_type: 'photo',
  orientation: 'horizontal',
  per_page: 20,
  page: 1,
  checkCountOfPhotos: 0,
  galleryList: document.querySelector('.gallery'),
  searchButton: document.querySelector('button[type="submit"]'),
  searchInput: document.querySelector('input'),
  loadMoreButton: document.querySelector('.load-more'),
  infoLoadingMessage: document.querySelector('.info--container'),
};
